import { Close, SaveOutlined } from '@mui/icons-material'
import { DialogActions, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomButton from '@/components/inputs/CustomButton'

type ConfigReviewDialogActionsProps = {
  isLoading?: boolean
  onCancel: () => void
  onSave: () => void
  onSaveAndRestart: () => void
}

export function ConfigReviewDialogActions({
  isLoading,
  onCancel,
  onSave,
  onSaveAndRestart,
}: Readonly<ConfigReviewDialogActionsProps>) {
  const { t } = useTranslation()

  return (
    <DialogActions>
      <Stack sx={{ flexDirection: 'row', gap: 1 }}>
        <CustomButton
          color="primary"
          disabled={isLoading}
          startIcon={<SaveOutlined />}
          type="button"
          variant="contained"
          onClick={onSave}
        >
          {t('common.button.save')}
        </CustomButton>
        <CustomButton
          color="primary"
          disabled={isLoading}
          startIcon={<SaveOutlined />}
          type="button"
          variant="contained"
          onClick={onSaveAndRestart}
        >
          {t('controllers.configuration.review_dialog.save_and_restart')}
        </CustomButton>
        <CustomButton
          color="primary"
          disabled={isLoading}
          startIcon={<Close />}
          type="reset"
          variant="outlined"
          onClick={onCancel}
        >
          {t('common.button.cancel')}
        </CustomButton>
      </Stack>
    </DialogActions>
  )
}
